import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { FeatureFlagKey } from '../../config/featureFlagKeys';

interface FeatureFlagProps {
    flag: FeatureFlagKey;
    children: React.ReactNode;
    fallback?: React.ReactNode;
}

const FeatureFlag: React.FC<FeatureFlagProps> = ({ flag, children, fallback = null }) => {
    const flags = useFlags();
    const isEnabled = !!flags[flag];

    if (isEnabled) {
        return <>{children}</>;
    }

    return <>{fallback}</>;
};

export default FeatureFlag;
